/**
 * 블로그 태그 slug 정규화 — 정규화의 단일 출처.
 *
 * 태그 문자열 자체가 slug 이며(별도 slug 필드 없음), 저장·URL 에는
 * **영문 소문자 + 국문 + `-`** 만 쓴다. 리스트 매핑·generateStaticParams·
 * 라우트 param 비교·표시 등 모든 소비처가 이 유틸만 경유해야 한다.
 */

/**
 * 태그 문자열 → slug.
 * trim → 영문 소문자화 → 공백을 `-` 로 → **한글·영문 소문자·숫자·`-` 외 문자 제거**
 * → 연속 `-` 축약 → 양끝 `-` 제거.
 * (허용 문자셋을 강제해 경로 구분자·HTML 특수문자 등이 라우트로 흘러들지 않게 한다.
 *  숫자는 `2차소견` 같은 태그를 위해 허용한다.)
 * 예) `WES` → `wes`, `Clinical Phenotype` → `clinical-phenotype`,
 *     `질환별 임상특징` → `질환별-임상특징`, `2차소견` → `2차소견`
 */
export const toTagSlug = (raw: string): string =>
  raw
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^가-힣a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');

/**
 * slug → 표시 라벨. `-` 만 공백으로 되돌린다(라벨 매핑 없음 — slug 가 곧 표시).
 * 예) `clinical-phenotype` → `clinical phenotype`, `wes` → `wes`
 */
export const toTagLabel = (slug: string): string => slug.replace(/-/g, ' ');

/**
 * CMS `blog.tags`(콤마 구분 문자열) → 정규화 slug 배열.
 * 각 값을 `toTagSlug` 로 정규화하고 빈 값은 제외한다.
 * 예) `"wes, mtdna, coverage"` → `['wes', 'mtdna', 'coverage']`
 */
export const parseTagList = (raw: unknown): string[] =>
  (typeof raw === 'string' ? raw : '')
    .split(',')
    .map(toTagSlug)
    .filter(Boolean);
